const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-pages', 'forum/components/PageHero');